import {
  aboutPagePath,
  contactPagePath,
  forBuyerPagePath,
  installmentPagePath,
  ourServicesPagePath,
  propertiesPagePath,
  adminPagePath
} from "../router/path";

export const menuItems = [
  {
    link: adminPagePath,
    text: "Admin",
  },
  {
    link: propertiesPagePath,
    text: "Nieruchomość",
  },
  {
    link: aboutPagePath,
    text: "O nas",
  },
  {
    link: ourServicesPagePath,
    text: "Usługi",
  },
  {
    link: forBuyerPagePath,
    text: "Dla kupujących",
  },
  {
    link: installmentPagePath,
    text: "Raty",
  },
  {
    link: contactPagePath,
    text: "Kontakty",
  },
];
